export const propMiscModals = {
  policia: {
    title: "Meldedaten",
    heading: "Hinterlegen Sie die Daten der zuständigen Behörden",
    subtitle:
      "Übermitteln Sie die Check-ins Ihrer Unterkunft automatisch an die Behörden",
    entityLabel: "Name der Behörde",
    entityPlaceholder: "Behörde auswählen",
    userLabel: "Benutzername",
    passwordLabel: "Passwort",
    accessError:
      "Prüfen Sie Ihre Zugangsdaten. Versuchen Sie es höchstens dreimal, sonst wird Ihr Konto möglicherweise gesperrt.",
    validateBtn: "Prüfen",
    saveBtn: "Daten speichern",
    entityRequired: "Die Behörde ist erforderlich",
    usernameRequired: "Der Benutzername ist erforderlich",
    passwordRequired: "Sie müssen das Passwort eingeben",
    validateError: "Fehler beim Prüfen der Daten",
    saveError: "Fehler beim Speichern der Daten der Ausländerbehörde",
  },
  upgrade: {
    heading: "Upgraden Sie Ihren Tarif, um weitere Unterkünfte anzulegen",
    message:
      "Hallo! Sie haben das Limit an Unterkünften in Ihrem aktuellen Tarif erreicht.",
    button: "Tarif upgraden",
  },
};
